var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "comments comments-wrap" },
    [
      _c("h2", { staticClass: "comments-title" }, [_vm._v("Comments")]),
      _vm._l(_vm.comments, function (comment) {
        return _c(
          "b-media",
          { key: comment.id, staticClass: "comment" },
          [
            _c("b-img", {
              staticClass: "gravatar",
              attrs: { src: comment.author_avatar_urls[48] },
            }),
            _c("h5", { staticClass: "comment-author" }, [
              _vm._v(_vm._s(comment.author_name)),
            ]),
            _c("div", {
              staticClass: "comment-content",
              domProps: { innerHTML: _vm._s(comment.content.rendered) },
            }),
          ],
          1
        )
      }),
      !_vm.comments.length
        ? _c("div", { staticClass: "message" }, [_vm._v("none yet")])
        : _vm._e(),
      !_vm.readOnly
        ? _c("comment-form", { attrs: { first: !_vm.comments.length } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }